'use client'

import React, { useContext, useEffect, useState } from 'react'
import SimpleTeaser from '@/components/Teaser/SimpleTeaser'
import { Title } from '@/components/Title'
import { PushContext, PushContextType } from '@/context/PushContext'
import { checkPushInit } from '@/libs/Pushes/pushes.lib'
import { ArchiveItem, WidgetPushProps } from '@/types/cms'
import { toKebabCase } from '@/utils/string'
import styles from './PushHistory.module.scss'
import SectionTitle from '@/components/SectionTitle/SectionTitle'

const WidgetPushHistory = ({ item }: { item: WidgetPushProps }) => {
  const [pushDeliveryReady, setPushDeliveryReady] = useState<boolean>(false) // window.pushDeliveryReady
  const [pushInitialized, setPushInitialized] = useState<boolean>(false)
  const [archive, setArchive] = useState<Array<ArchiveItem> | null>(null)
  const pushContext = useContext(PushContext)
  const { updateIsOpen, permission, updatePermission } = pushContext as PushContextType

  useEffect(() => {
    window.addEventListener('message', (event) => {
      if (event.origin !== globalThis.window.origin) return
      if (event.data === 'pushDeliveryReady') {
        setPushDeliveryReady(() => true)
      }
    })
  }, [])

  useEffect(() => {
    if (pushDeliveryReady) {
      checkPushInit(updateIsOpen, updatePermission)
        .then(() => {
          setPushInitialized(() => true)
        })
        .catch((error) => {
          console.log('pushDelivery not available', error)
        })
    }
  }, [pushDeliveryReady, updateIsOpen, updatePermission])

  useEffect(() => {
    if (pushInitialized && permission) {
      globalThis.window.pushDelivery.storageService.init().then(() => {
        globalThis.window.pushDelivery
          .getArchive()
          .then((res: Array<ArchiveItem>) => {
            setArchive(() => res)
          })
          .catch((error: Error) => {
            console.log('Archive not available', error)
          })
      })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pushInitialized])

  return (
    <>
      <section>
        {item.model?.fields?.headline && <Title>{item.model.fields.headline}</Title>}
        {item.model?.fields?.shorttext && <p>{item.model.fields.shorttext}</p>}
      </section>
      <section>
        <SectionTitle title="Push Historie" />
        {(!archive || archive.length == 0) && permission && (
          <div className={styles['no-history']}>
            <p>Bisher sind keine Push-Nachrichten eingegangen.</p>
          </div>
        )}
        {!permission && (
          <div className={styles['no-history']}>
            <p>Sie sind nicht für Push Nachrichten angemeldet</p>
          </div>
        )}
        <div className={styles.grid}>
          {archive &&
            archive.length > 0 &&
            archive.map((item, index) => (
              <React.Fragment key={toKebabCase(item.data.title) + index}>
                <SimpleTeaser teaser={item} />
              </React.Fragment>
            ))}
        </div>
      </section>
    </>
  )
}

export default WidgetPushHistory
